import { useParams } from 'react-router-dom'
import { CheckoutButton, useApiQuery, useToast } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'

/** Equivalent of legacy `ProductListComponent` (audit §3/§6 — one-off product
 * purchase list). `:productId` highlights that product, same rationale as
 * `PlanListPage`. */
export function ProductListPage() {
  const { productId } = useParams<{ productId?: string }>()
  const { data: products, loading, error } = useApiQuery(() => paymentClient.listProducts(), [])
  const { showToast } = useToast()

  return (
    <div>
      <h1>Products</h1>
      {loading && <p>Loading products…</p>}
      {error && <p role="alert">Could not load products.</p>}
      {(products ?? []).map((product) => (
        <div
          key={product.id ?? product.name}
          className="screener-card"
          style={product.id === productId ? { borderColor: 'var(--gbx-accent)' } : undefined}
        >
          <h2>{product.name}</h2>
          {product.price != null && (
            <p>
              {product.price} {product.currency ?? ''}
            </p>
          )}
          {product.onetimeproduct?.status === 1 ? (
            <p>Already purchased.</p>
          ) : (
            product.id && (
              <CheckoutButton
                payment={paymentClient}
                cause="product-purchase"
                target={{ kind: 'product', ids: [product.id] }}
                onError={(msg) => showToast(msg, 'error')}
              >
                Buy
              </CheckoutButton>
            )
          )}
        </div>
      ))}
    </div>
  )
}
